import React from 'react';
import classnames from 'classnames/bind';
import styles from './chatBox.module.scss';

const classNameBuilder = classnames.bind(styles);

export const ChatBox = React.forwardRef(({ children, className, testIdPrefix, ...props }, ref) => {
    return (
        <div
            ref={ref}
            className={classNameBuilder('chat-box', className)}
            data-testid={`${testIdPrefix}-chat-box`}
            {...props}
        >
            {children}
        </div>
    );
});
